import { render, staticRenderFns } from "./ClassView.vue?vue&type=template&id=0e7704a6&scoped=true"
import script from "./ClassView.vue?vue&type=script&lang=js"
export * from "./ClassView.vue?vue&type=script&lang=js"
import style0 from "./ClassView.vue?vue&type=style&index=0&id=0e7704a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7704a6",
  null
  
)

export default component.exports